import { apiService } from "../../services/apiService";

const Api = apiService.injectEndpoints({
    endpoints: builder => ({

        /* ===============================
           SMTP
        =============================== */

        updateCredentials: builder.mutation({
            query: (body) => ({
                url: "siteSetting/updateSmtpCredentials",
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        getSmtpCredentials: builder.query({
            query: () => ({
                url: "siteSetting/getSmtpCredentials"
            }),
            providesTags: ["FlexzaiDialerAdmin"],
        }),

        /* ===============================
           CALL / SIP TRUNK CONFIGURATION
        =============================== */

        updateCallCredentials: builder.mutation({
            query: (body) => ({
                url: "siteSetting/updateCallCredentials",
                method: "POST",
                body
            }),
            invalidatesTags: [
                "FlexzaiDialerAdmin",
                "AsteriskStatus"
            ],
        }),

        getCallCredentials: builder.query({
            query: () => ({
                url: "siteSetting/getCallCredentials"
            }),
            providesTags: ["FlexzaiDialerAdmin"],
        }),

        /* ===============================
           ASTERISK STATUS
        =============================== */

        getAsteriskStatus: builder.query({
            query: () => ({
                url: "siteSetting/getAsteriskStatus",
                method: "GET"
            }),
            providesTags: ["AsteriskStatus"],
        }),

        testTrunkConnection: builder.mutation({
            query: (body = {}) => ({
                url: "siteSetting/testTrunkConnection",
                method: "POST",
                body
            }),
            invalidatesTags: ["AsteriskStatus"],
        }),

        reloadDialplan: builder.mutation({
            query: (body = {}) => ({
                url: "siteSetting/reloadDialplan",
                method: "POST",
                body
            }),
            invalidatesTags: ["AsteriskStatus"],
        }),

        reloadPjsip: builder.mutation({
            query: (body = {}) => ({
                url: "siteSetting/reloadPjsip",
                method: "POST",
                body
            }),
            invalidatesTags: [
                "AsteriskStatus",
                "FlexzaiDialerAdmin"
            ],
        }),

        restartAsterisk: builder.mutation({
            query: (body = {}) => ({
                url: "siteSetting/restartAsterisk",
                method: "POST",
                body
            }),
            invalidatesTags: ["AsteriskStatus"],
        }),

        /* ===============================
           SITE CREDENTIALS
        =============================== */

        getSiteCredentials: builder.query({
            query: () => ({
                url: "siteSetting/getSiteCredentials"
            }),
            providesTags: ["FlexzaiDialerAdmin"],
        }),

        updateSiteCredentials: builder.mutation({
            query: (body) => ({
                url: "siteSetting/updateSiteCredentials",
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

        /* ===============================
           CALL TIMER
        =============================== */

        getCallTimer: builder.query({
            query: () => ({
                url: "siteSetting/getCallTimer"
            }),
            providesTags: ["FlexzaiDialerAdmin"],
        }),

        updateCallTimer: builder.mutation({
            query: (body) => ({
                url: "siteSetting/updateCallTimer",
                method: "POST",
                body
            }),
            invalidatesTags: ["FlexzaiDialerAdmin"],
        }),

    }),

    overrideExisting: false
});

export const {
    useUpdateCredentialsMutation,
    useGetSmtpCredentialsQuery,

    useGetCallCredentialsQuery,
    useUpdateCallCredentialsMutation,

    useGetAsteriskStatusQuery,
    useTestTrunkConnectionMutation,
    useReloadDialplanMutation,
    useReloadPjsipMutation,
    useRestartAsteriskMutation,

    useGetSiteCredentialsQuery,
    useUpdateSiteCredentialsMutation,

    useGetCallTimerQuery,
    useUpdateCallTimerMutation
} = Api;

export default Api;